"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StringResources_1 = __importDefault(require("../../nls/StringResources"));

var ICON_MAP = [{
  shapeId: 'upArrow',
  iconId: 'conditionalFormatting-arrow-up_16',
  label: StringResources_1.default.get('conditionalFormattingIconArrowUp')
}, {
  shapeId: 'rightArrow',
  iconId: 'conditionalFormatting-arrow-right_16',
  label: StringResources_1.default.get('conditionalFormattingIconArrowRight')
}, {
  shapeId: 'downArrow',
  iconId: 'conditionalFormatting-arrow-down_16',
  label: StringResources_1.default.get('conditionalFormattingIconArrowDown')
}, {
  shapeId: 'upCaret',
  iconId: 'conditionalFormatting-caret-up_16',
  label: StringResources_1.default.get('conditionalFormattingIconCaretUp')
}, {
  shapeId: 'dash',
  iconId: 'conditionalFormatting-dash_16',
  label: StringResources_1.default.get('conditionalFormattingIconDash')
}, {
  shapeId: 'downCaret',
  iconId: 'conditionalFormatting-caret-down_16',
  label: StringResources_1.default.get('conditionalFormattingIconCaretDown')
}, {
  shapeId: 'checkmark',
  iconId: 'conditionalFormatting-checkmark_16',
  label: StringResources_1.default.get('conditionalFormattingIconCheckmark')
}, {
  shapeId: 'warning',
  iconId: 'conditionalFormatting-warning_16',
  label: StringResources_1.default.get('conditionalFormattingIconWarning')
}, {
  shapeId: 'xSymbol',
  iconId: 'conditionalFormatting-x-symbol_16',
  label: StringResources_1.default.get('conditionalFormattingIconXSymbol')
}, {
  shapeId: 'circle',
  iconId: 'conditionalFormatting-circle_16',
  label: StringResources_1.default.get('conditionalFormattingIconCircle')
}, {
  shapeId: 'triangle',
  iconId: 'conditionalFormatting-triangle_16',
  label: StringResources_1.default.get('conditionalFormattingIconTriangle')
}, {
  shapeId: 'diamond',
  iconId: 'conditionalFormatting-diamond_16',
  label: StringResources_1.default.get('conditionalFormattingIconDiamond')
}, {
  shapeId: 'satisfied',
  iconId: 'conditionalFormatting-face-satisfied_16',
  label: StringResources_1.default.get('conditionalFormattingIconFaceSatisfied')
}, {
  shapeId: 'neutral',
  iconId: 'conditionalFormatting-face-neutral_16',
  label: StringResources_1.default.get('conditionalFormattingIconFaceNeutral')
}, {
  shapeId: 'dissatisfied',
  iconId: 'conditionalFormatting-face-dissatisfied_16',
  label: StringResources_1.default.get('conditionalFormattingIconFaceDissatisfied')
}, {
  shapeId: 'none',
  iconId: 'conditionalFormatting-noshape_16',
  label: StringResources_1.default.get('conditionalFormattingIconNone')
}];
var iconDefinitions;
var iconsMap = new Map();

var IconsMap =
/** @class */
function () {
  function IconsMap() {}

  IconsMap.getIconDefinitions = function (iconsApi) {
    IconsMap._loadIconDefinitions(iconsApi);

    return iconDefinitions;
  };

  IconsMap.getShapeDefinition = function (iconsApi, shapeId) {
    IconsMap._loadIconDefinitions(iconsApi);

    var definition = iconsMap.get(shapeId) || null;
    return definition;
  };

  IconsMap._loadIconDefinitions = function (iconsApi) {
    void iconsApi;

    if (!iconDefinitions) {
      iconDefinitions = [];
      ICON_MAP.forEach(function (item) {
        var definition = {
          iconId: item.iconId,
          label: item.label,
          shapeId: item.shapeId
        };
        iconDefinitions.push(definition);
        iconsMap.set(item.shapeId, definition);
      });
    }
  };

  return IconsMap;
}();

exports.default = IconsMap;
